module.exports = __webpack_public_path__ + "static/media/incoming.5590a318.svg";